module.exports = __webpack_public_path__ + "static/media/no-avatar-blue.73974d7e.jpg";